// Busca os grupos econômicos e seus ids, somente

import axios from 'axios'
import apiErrorHandler from '../utils/apiErrorHandler'
import store from '@/store'

async function getAllGroupsByProviderId(providerId, params) {
    try {
        
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/economicgroup/provider/${providerId}`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            },
            params,
        })

        return result.data.payload
    } catch (e) {
        apiErrorHandler(e.response.status)
        return e.response
    }

}

export default getAllGroupsByProviderId